import { SET_DEALER_ADDRESS } from '../actions/types';

const initialState = {
	address1: '',
	address2: '',
	address3: '',
	city: '',
	state: '',
	postalCode: '',
	country: ''
};

export default function dealerAddress(state = initialState, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_DEALER_ADDRESS:
				return { ...state, ...action.payload };
			default:
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/dealerAddress.js